import { render, staticRenderFns } from "./ShadowButton.vue?vue&type=template&id=0d629a54&scoped=true&"
import script from "./ShadowButton.vue?vue&type=script&lang=js&"
export * from "./ShadowButton.vue?vue&type=script&lang=js&"
import style0 from "./ShadowButton.vue?vue&type=style&index=0&id=0d629a54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d629a54",
  null
  
)

export default component.exports